import * as React from 'react';
import { useSelector } from 'react-redux';

import { TBannerTheme } from '../../components/NewbuildingBanners/utils/bannerTypeToTheme';
import { PromosBanner } from '../../components/NewbuildingBanners/PromosBanner/PromosBanner';
import { CompilationBanner } from '../../components/NewbuildingBanners/CompilationBanner/CompilationBanner';
import { NewbuildingBrokerBanner } from '../../components/NewbuildingBanners/NewbuildingBrokerBanner/NewbuildingBrokerBanner';
import { NewbuildingBrokerBanner as NewbuildingBrokerBannerExperimental } from '../../components/NewbuildingBanners/NewbuildingBrokerBannerExperimental/NewbuildingBrokerBanner';
import { selectNewbuildingBrokerSelfRequestFormExperimentEnabled } from '../../selectors/newbuildings/newbuildingBrokerSelfRequestFormWidget';
import { TBanners, TBannerTypes } from '../../types/newbuildingBanners/banners';
import { useNewbuildingBrokerWidgetBanner } from './useNewbuildingBrokerWidgetBanner';

interface IThemeMapperProps {
  type: TBannerTypes;
}

interface IUseBannerProp {
  themeMapper(props: IThemeMapperProps): TBannerTheme;
  data: TBanners;
  onClick(): void;
}

export const Banner = ({ themeMapper, data, onClick }: IUseBannerProp) => {
  const isNewbuildingBrokerWidgetExperiment = useSelector(selectNewbuildingBrokerSelfRequestFormExperimentEnabled);
  const { isLoading: isNewbuildingBrokerWidgetLoading, clickHandler: newbuildingBrokerWidgetBannerClickHandler } =
    useNewbuildingBrokerWidgetBanner();

  switch (data.type) {
    case 'allPromos':
      return <PromosBanner onClick={onClick} theme={themeMapper({ type: data.type })} {...data} />;
    case 'lastChanceDiscount':
      return <CompilationBanner onClick={onClick} theme={themeMapper({ type: data.type })} {...data} />;
    case 'topPromos':
      return <CompilationBanner onClick={onClick} theme={themeMapper({ type: data.type })} {...data} />;
    case 'newbuildingBroker': {
      if (isNewbuildingBrokerWidgetExperiment) {
        return (
          <NewbuildingBrokerBannerExperimental
            onClick={newbuildingBrokerWidgetBannerClickHandler}
            theme={themeMapper({ type: data.type })}
            {...data}
            loading={isNewbuildingBrokerWidgetLoading}
          />
        );
      }

      return <NewbuildingBrokerBanner onClick={onClick} theme={themeMapper({ type: data.type })} {...data} />;
    }
  }
};
